/**
 * @module
 * @author
 * @version 1.0
 * @description 协议组件
 * @description [三端统一接入]
 * @description [去除第三方域名屏蔽]
 * @description [协议相关基础功能，不能依赖任何自建组件]
 */

//全局变量定义
var G_DEFAULT_PROTOCOL = 'https://'; //默认https

var Protocol = {
    /**
     * @function getProtocol  
     * @description 判断当前链接协议的方法，此方法暂时不用， 因android给的当前页url存在问题
     * @version 2.0
     * @instance
     * @returns {string}
     * @example
     * Protocol.getProtocol(); //return 'https://'
     */
    getProtocol: function () {
        var protocol = G_DEFAULT_PROTOCOL;

        if (window && window.location && window.location.href) {
            var crt_url = window.location.href,
                reg_all_http = /^(http:\/\/)/,
                reg_all_https = /^(https:\/\/)/;

            if (reg_all_http.test(crt_url)) {
                protocol = 'http://';
            } else if (reg_all_https.test(crt_url)) {
                protocol = 'https://';
            }
        }

        return protocol;
    },

    /**
     * @function getDefaultProtocol  
     * @description 获取默认协议
     * @version 2.0
     * @instance
     * @returns {string}
     * @example
     * Protocol.getDefaultProtocol(); //return 'https://'
     */
    getDefaultProtocol: function () {
        return G_DEFAULT_PROTOCOL;
    },

    /**
     * @function addUrlProtocol
     * @param {string} url - 链接
     * @param {function} callback_openurl - 回调函数
     * @description 补充url协议
     * @version 2.0
     * @instance
     * @returns {string}
     * @example
     * Protocol.addUrlProtocol('m.fenqile.com'); //return 'https://m.fenqile.com'
     */
    addUrlProtocol: function (url, callback_openurl) {
        var _this = this;
        if (!url) {
            return false;
        }

        var default_protocol = this.getDefaultProtocol(), //默认直接返回https
            reg_all = /^(http:\/\/|https:\/\/|\/\/|)[\w\-_.]+(fenqile|juzilicai|mycaidan|mac4me)\.(cn|com)/, //http https // 无都匹配
            reg_prefix = /^(http:\/\/|https:\/\/|\/\/|)/; //直接替换

        if (reg_all.test(url)) {
            //站内域名默认走https
            url = url.replace(reg_prefix, default_protocol);
        } else {
            var reg_prefix_protocol = /^(http:\/\/|https:\/\/)/;
            //如果外链接没带协议默认给http的协议
            if (!reg_prefix_protocol.test(url)) {
                url = url.replace(reg_prefix, 'http://');
            }
        }

        if (!callback_openurl) {
            //站内请求只需要添加协议
            return url;
        } else {
            //跳转在回调完成
            if (typeof callback_openurl == 'function') {
                callback_openurl(url); //页面跳转在回调处理
            }
        }
    }
};

export default Protocol;